import { instance } from "../index";

// Login an existing account (email/password). Anonymous app accounts have no
// email and cannot log in here — they must link an email in the app first.
export const login = async ({ email, password }) => {
  try {
    const { data } = await instance.post("/api/user/login", {
      email,
      password,
    });
    return data; // { token, ...user }
  } catch (error) {
    throw error.response?.data || { message: "حدث خطأ، حاول مرة أخرى" };
  }
};

// Create a new account with email/password (web-only signup endpoint).
export const registerEmail = async ({ email, password, gameName }) => {
  try {
    const { data } = await instance.post("/api/user/register-email", {
      email,
      password,
      gameName,
    });
    return data; // { token, ...user }
  } catch (error) {
    throw error.response?.data || { message: "حدث خطأ، حاول مرة أخرى" };
  }
};

// Swap a one-time ticket from the mobile app ("open the website") for a
// session. The ticket works once and expires within minutes.
export const exchangeHandoff = async (token) => {
  const { data } = await instance.post("/api/user/web-handoff/exchange", {
    token,
  });
  return data; // { token, ...user }
};

export const getProfile = async (userId) => {
  const { data } = await instance.get(`/api/user/profile/${userId}`);
  return data;
};
